import { Pipe, PipeTransform } from '@angular/core';
import { TimeRegistrationStatus, TimeRegistrationType } from '../../enums/enums';
import { IProject, ITimeRegistration } from '../../model/top.model';

@Pipe({
  name: 'timeRegistrationStatus',
})
export class TimeRegistrationStatusPipe implements PipeTransform {
  transform(value: number, ...args) {
    switch (value) {
      case TimeRegistrationStatus.checked:
        return 'Gecontroleerd';
      case TimeRegistrationStatus.approved:
        return 'Goedgekeurd';
      case TimeRegistrationStatus.done:
        return 'Klaar';
      case TimeRegistrationStatus.open:
        return 'Open';
      case TimeRegistrationStatus.rejected:
        return 'Afgekeurd';
      case TimeRegistrationStatus.submitted:
        return 'Ingediend';
      default:
        return 'Leeg';
    }
  }
}

@Pipe({
  name: 'timeRegistrationType',
})
export class TimeRegistrationTypePipe implements PipeTransform {
  transform(value: number, ...args) {
    switch (value) {
      case TimeRegistrationType.OpbouwTijdVoorTijd:
        return 'Opbouw tijd voor tijd';
      case TimeRegistrationType.OpnameTijdVoorTijd:
        return 'Opname tijd voor tijd';
      case TimeRegistrationType.VerlofADV:
        return 'Verlof ATV';
      case TimeRegistrationType.VerlofSpeciaal:
        return 'Verlof speciaal';
      case TimeRegistrationType.VerlofVrijeDag:
        return 'Verlof vrije dag';
      case TimeRegistrationType.FeestDag:
        return 'Verlof feest dag';
      case TimeRegistrationType.DokterTandarts:
        return 'Dokter/Tandarts';
      case TimeRegistrationType.Ziek:
        return 'Ziek';
      case TimeRegistrationType.Projecten:
        return 'Projecten';
      case TimeRegistrationType.projectenWVB:
        return 'Projecten WVB';
      case TimeRegistrationType.Tekenwerk:
        return 'Tekenwerk';
      case TimeRegistrationType.Planning:
        return 'Planning';
      case TimeRegistrationType.Verkoopactiviteit:
        return 'Verkoop activiteit';
      case TimeRegistrationType.Werkbespreking:
        return 'Werkbespreking';
      case TimeRegistrationType.Vergadering:
        return 'Vergadering';
      case TimeRegistrationType.MT:
        return 'MT';
      case TimeRegistrationType.DT:
        return 'DT';
      case TimeRegistrationType.Bestellingen:
        return 'Bestellingen';
      case TimeRegistrationType.Administratie:
        return 'Administratie';
      case TimeRegistrationType.Secretarieel:
        return 'Secretarieel';
      case TimeRegistrationType.Automatisering:
        return 'Automatisering';
      case TimeRegistrationType.Dossierbeheer:
        return 'Dossierbeheer';
      case TimeRegistrationType.Personeel:
        return 'Personeel';
      case TimeRegistrationType.Studie:
        return 'Studie';
      case TimeRegistrationType.Overig:
        return 'Overig';
      case TimeRegistrationType.Verhuur:
        return 'Verhuur';
      case TimeRegistrationType.ProjectNCC:
        return 'Projecten NCC';
      case TimeRegistrationType.projectTOP:
        return 'Projecten TOP';
      case TimeRegistrationType.projectService:
        return 'Projecten Service';
      case TimeRegistrationType.Schoonmaak:
        return 'Schoonmaak';
      case TimeRegistrationType.Service:
        return 'Service';
      case TimeRegistrationType.Reisuren:
        return 'Reisuren';
      case TimeRegistrationType.Transport:
        return 'Transport';
      case TimeRegistrationType.Scholing:
        return 'Scholing';
      case TimeRegistrationType.NietGewerkt:
        return 'Niet gewerkt';
      default:
        return 'Onbekend!!!';
    }
  }
}

@Pipe({
  name: 'timeRegistrationsHours',
})
export class TimeRegistrationsHoursPipe implements PipeTransform {
  transform(project: IProject, ...args) {
    let totalHours = 0;
    project.timeRegistrations.forEach((timeRegistration) => {
      totalHours += parseInt(timeRegistration.mondayHHmm.substr(0, 2));
      if (timeRegistration.mondayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
      totalHours += parseInt(timeRegistration.tuesdayHHmm.substr(0, 2));
      if (timeRegistration.tuesdayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
      totalHours += parseInt(timeRegistration.wednesdayHHmm.substr(0, 2));
      if (timeRegistration.wednesdayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
      totalHours += parseInt(timeRegistration.thursdayHHmm.substr(0, 2));
      if (timeRegistration.thursdayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
      totalHours += parseInt(timeRegistration.fridayHHmm.substr(0, 2));
      if (timeRegistration.fridayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
      totalHours += parseInt(timeRegistration.saturdayHHmm.substr(0, 2));
      if (timeRegistration.saturdayHHmm.charAt(4) === '3') {
        totalHours += 0.5;
      }
    });
    return totalHours;
  }
}

@Pipe({
  name: 'timeRegistrationsByWeek',
})
export class TimeRegistrationsByWeek implements PipeTransform {
  transform(timeRegistrations: ITimeRegistration[], week: number, year: number, type: string) {
    if (!timeRegistrations) {
      return;
    }
    return timeRegistrations.filter((timeRegistration) => {
      let typeMatch: boolean;
      if (!timeRegistration.project_id) {
        timeRegistration.project_id = "\u0000";
      }
      switch (type) {
        case "leave":
          typeMatch = timeRegistration.type < 4 && timeRegistration.project_id.indexOf("\u0000") > -1;
          break;
        case "service":
          typeMatch = timeRegistration.type > 20 && timeRegistration.project_id.indexOf("\u0000") > -1;
          break;
        case "office":
          typeMatch = timeRegistration.type > 4 && timeRegistration.type < 21 && timeRegistration.project_id.indexOf("\u0000") > -1;
          break;
        default:
          typeMatch = timeRegistration.type > 4 && timeRegistration.type < 21 && timeRegistration.project_id.indexOf("\u0000") == -1;
          break;
      }
      return (
        timeRegistration.year == year &&
        timeRegistration.week == week &&
        typeMatch
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time-registration-pipe/time-registration-pipe.ts